import { Avatar, Box, Drawer, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { header_content } from '../../../../../data/general_texts';
import { useAuth } from '../../../../../contexts/AuthProvider';
import { getDrawerLinks, getGreetingInitial, getGreetingName } from '../../partnerNav';

const CustomDrawer = ({ open, toggleDrawer, onSignOut }) => {
    const { isAuthenticated, user, userName } = useAuth();
    const greetName = getGreetingName(user, userName);
    const accountLinks = getDrawerLinks(user);

    return (
        <Drawer
            anchor="top"
            open={open}
            onClose={toggleDrawer(false)}
            slotProps={{
                paper: { sx: styles.paper },
            }}
        >
            {isAuthenticated && (
                <Box sx={styles.greetingBox}>
                    <Avatar src={user?.image || undefined} alt={greetName} sx={styles.avatar}>
                        {getGreetingInitial(greetName)}
                    </Avatar>
                    <Typography sx={styles.greetingText}>Olá, {greetName}</Typography>
                </Box>
            )}
            <List onClick={toggleDrawer(false)} sx={styles.list}>
                {isAuthenticated ? (
                    <>
                        {accountLinks.map((link) => (
                            <ListItem key={link.to} disablePadding>
                                <ListItemButton component={RouterLink} to={link.to} sx={styles.item}>
                                    <ListItemText primary={link.title} primaryTypographyProps={styles.itemText} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                        <ListItem disablePadding>
                            <ListItemButton onClick={onSignOut} sx={styles.item}>
                                <ListItemText primary="Sair" primaryTypographyProps={styles.signOutText} />
                            </ListItemButton>
                        </ListItem>
                    </>
                ) : (
                    <>
                        {header_content.main_links.map((link) => (
                            <ListItem key={link.title} disablePadding>
                                <ListItemButton href={link.link} sx={styles.item}>
                                    <ListItemText primary={link.title} primaryTypographyProps={styles.itemText} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                        <ListItem disablePadding>
                            <ListItemButton component={RouterLink} to="/login" sx={styles.item}>
                                <ListItemText
                                    primary={header_content.auth_content.text}
                                    primaryTypographyProps={styles.signOutText}
                                />
                            </ListItemButton>
                        </ListItem>
                    </>
                )}
            </List>
        </Drawer>
    );
};

const styles = {
    paper: {
        bgcolor: 'primary.main',
        color: 'common.white',
        borderBottom: '2px solid',
        borderColor: 'secondary.main',
        backgroundImage: 'none',
    },
    greetingBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        px: 2.5,
        pt: 2.5,
        pb: 1,
    },
    avatar: {
        width: 36,
        height: 36,
        fontSize: '0.8rem',
        fontWeight: 600,
        bgcolor: 'secondary.main',
        color: 'primary.main',
    },
    greetingText: {
        fontSize: '0.9375rem',
        fontWeight: 500,
    },
    list: {
        pt: 0.5,
        pb: 1.5,
    },
    item: {
        px: 2.5,
        '&:hover': {
            bgcolor: 'transparent',
            color: 'secondary.main',
        },
    },
    itemText: {
        fontSize: '0.9375rem',
        fontWeight: 500,
    },
    signOutText: {
        fontSize: '0.9375rem',
        fontWeight: 600,
        color: 'secondary.main',
    },
};

export default CustomDrawer;
